import "./blitzLoading.css";

/** Shared loading state for startup, pages, and smaller content regions. */
export default function BlitzLoading({ label = "Loading…", compact = false, className = "" }: {
  label?: string;
  compact?: boolean;
  className?: string;
}) {
  return <div className={`blitz-loading${compact ? " blitz-loading--compact" : ""}${className ? ` ${className}` : ""}`} role="status" aria-live="polite" aria-atomic="true">
    <img className="blitz-loading__mark" src={`${import.meta.env.BASE_URL}blitzclinic-b-v3.svg`} width="44" height="44" alt="" aria-hidden="true" />
    <span className="blitz-loading__label">{label}</span>
  </div>;
}
